// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-products {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 60px;
}

.w-400 {
  width: 400px;
}

.div-container {
  background: #e3eeed;
  padding: 30px;
  display: flex;
  justify-content: space-evenly;
  transition: 1.4s;
}

.font-button {
  background: none;
  border: none;
}

.filter-class {
  display: flex;
  justify-content: center;
  height: 40px;
  border-radius: 25px;
  border: 2px solid #e3eeed;
  width: 300px;
  padding: 0.5rem 1rem;
  position: relative;
}

.con-review {
  height: 75px;
  width: 100%;
}

.sort-flex {
  display: flex;
  justify-content: end;
  position: absolute;
  right: 25px;
}

.sort-flex-1 {
  display: grid;
  place-items: end;
  position: absolute;
  right: 383px;
  top: 65px;
}

.sort-flex-2 {
  display: grid;
  place-items: end;
  position: absolute;
  right: 650px;
}

.con-button {
  display: flex;
  justify-content: center;
  gap: 20px;
  background: #ffffff;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  z-index: 999;
}

.buttn-cancel {
  width: auto !important;
  height: 40px !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 10px !important;
  padding: 8px 30px !important;
  border-radius: 4px !important;
  flex-grow: 0;
  font-family: "Open Sans" !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.5 !important;
  letter-spacing: normal !important;
  text-align: center !important;
  color: #00889b !important;
}

@media (min-width: 768px) and (max-width: 1280px) {
  .sort-flex-1 .grid-class {
    width: 80%;
    z-index: 111;
  }
}
.ingriedents-container {
  width: 350px;
  min-height: 190px;
  max-height: 190px;
  border-radius: 10px;
  border: 1px solid #e3eeed;
  overflow-x: hidden;
  overflow-y: auto;
  background: #ffffff;
}

.ing-header {
  background: #00889b;
  color: #ffffff;
  display: flex;
  justify-content: center;
  padding: 4px;
}

.ing-header-1 {
  background: #555555;
  display: flex;
  justify-content: center;
  color: #ffffff;
  padding: 4px;
}

.code-input-2 {
  height: 40px;
  align-self: stretch;
  flex-grow: 0;
  border-radius: 4px;
  border: solid 1px #e7edef;
  background-color: #fff;
  padding: 10px;
  color: #21756d;
}

.code-input-3 {
  width: 40% !important;
  align-self: stretch !important;
  flex-grow: 0;
  border-radius: 4px !important;
  border: solid 1px #e7edef !important;
  background-color: #fff;
  padding: 10px;
  color: #21756d;
}

.w-20 {
  width: 40%;
}

.p-44-4 {
  padding-right: 300px !important;
  gap: 50px;
  padding-bottom: 20px !important;
}

.product-review-action-button {
  cursor: pointer;
  color: #00889b;
  font-weight: 600;
  font-family: "Open Sans";
}

.product-review-progress-bar {
  color: #00889b;
  background-color: #00889b;
}

.product-review-date-picker-container {
  position: absolute;
  top: 42px;
  right: 0;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/pages/learning/ReviewProduct.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AACA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,qFAAA;EACA,YAAA;AAEJ;;AACA;EACI,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,8BAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,YAAA;EACA,mCAAA;EACA,0BAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EACA,2BAAA;EACA,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;;AACA;EACG;IACC,UAAA;IACA,YAAA;EAEF;AACF;AACA;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AACJ;;AAEA;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;AACJ;;AAEA;EACI,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,6BAAA;EACA,oCAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,+BAAA;EACA,SAAA;EACA,+BAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,cAAA;EACA,yBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;AACJ","sourcesContent":[".review-products {\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 60px;\n}\n\n.w-400 {\n    width: 400px;\n}\n\n.div-container {\n    background: #e3eeed;\n    padding: 30px;\n    display: flex;\n    justify-content: space-evenly;\n    transition: 1.4s;\n}\n\n.font-button {\n    background: none;\n    border: none;\n}\n\n.filter-class {\n    display: flex;\n    justify-content: center;\n    height: 40px;\n    border-radius: 25px;\n    border: 2px solid #e3eeed;\n    width: 300px;\n    padding: 0.5rem 1rem;\n    position: relative;\n}\n\n.con-review {\n    height: 75px;\n    width: 100%;\n}\n\n.sort-flex {\n    display: flex;\n    justify-content: end;\n    position: absolute;\n    right: 25px;\n}\n\n.sort-flex-1 {\n    display: grid;\n    place-items: end;\n    position: absolute;\n    right: 383px;\n    top: 65px;\n}\n\n.sort-flex-2 {\n    display: grid;\n    place-items: end;\n    position: absolute;\n    right: 650px;\n}\n.con-button {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    background: #ffffff;\n    padding: 20px;\n    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;\n    z-index: 999;\n}\n\n.buttn-cancel {\n    width: auto !important;\n    height: 40px !important;\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: center !important;\n    align-items: center !important;\n    gap: 10px !important;\n    padding: 8px 30px !important;\n    border-radius: 4px !important;\n    flex-grow: 0;\n    font-family: 'Open Sans' !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    font-stretch: normal !important;\n    font-style: normal !important;\n    line-height: 1.5 !important;\n    letter-spacing: normal !important;\n    text-align: center !important;\n    color: #00889b !important;\n}\n\n@media (min-width: 768px) and (max-width:1280px){\n   .sort-flex-1 .grid-class {\n    width: 80%;\n    z-index: 111;\n   }\n}\n\n.ingriedents-container {\n    width: 350px;\n    min-height: 190px;\n    max-height: 190px;\n    border-radius: 10px;\n    border: 1px solid #e3eeed;\n    overflow-x: hidden;\n    overflow-y: auto;\n    background: #ffffff;\n}\n\n.ing-header {\n    background: #00889b;\n    color: #ffffff;\n    display: flex;\n    justify-content: center;\n    padding: 4px;\n}\n\n.ing-header-1 {\n    background: #555555;\n    display: flex;\n    justify-content: center;\n    color: #ffffff;\n    padding: 4px;\n}\n\n.code-input-2 {\n    height: 40px;\n    align-self: stretch;\n    flex-grow: 0;\n    border-radius: 4px;\n    border: solid 1px #e7edef;\n    background-color: #fff;\n    padding: 10px;\n    color: #21756d;\n}\n\n.code-input-3 {\n    width: 40% !important;\n    align-self: stretch !important;\n    flex-grow: 0;\n    border-radius: 4px !important;\n    border: solid 1px #e7edef !important;\n    background-color: #fff;\n    padding: 10px;\n    color: #21756d;\n}\n\n.w-20 {\n    width: 40%;\n}\n\n.p-44-4 {\n    padding-right: 300px !important;\n    gap: 50px;\n    padding-bottom: 20px !important;\n}\n\n.product-review-action-button {\n    cursor: pointer;\n    color: #00889b;\n    font-weight: 600;\n    font-family: \"Open Sans\";\n}\n\n.product-review-progress-bar {\n    color: #00889b;\n    background-color: #00889b;\n}\n\n.product-review-date-picker-container {\n    position: absolute;\n    top: 42px;\n    right: 0;\n    z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
